__turbopack_context__.v({
  "memberCard": "ForClubsMembers-module-scss-module__h-1ZpG__memberCard",
  "memberCardEmpty": "ForClubsMembers-module-scss-module__h-1ZpG__memberCardEmpty",
  "memberCardEmptyContent": "ForClubsMembers-module-scss-module__h-1ZpG__memberCardEmptyContent",
  "memberCardEmptyIcon": "ForClubsMembers-module-scss-module__h-1ZpG__memberCardEmptyIcon",
  "memberCardEmptyNonInteractive": "ForClubsMembers-module-scss-module__h-1ZpG__memberCardEmptyNonInteractive",
  "memberCardEmptyPlus": "ForClubsMembers-module-scss-module__h-1ZpG__memberCardEmptyPlus",
  "memberHead": "ForClubsMembers-module-scss-module__h-1ZpG__memberHead",
  "memberInfo": "ForClubsMembers-module-scss-module__h-1ZpG__memberInfo",
  "memberLocation": "ForClubsMembers-module-scss-module__h-1ZpG__memberLocation",
  "memberLocationDot": "ForClubsMembers-module-scss-module__h-1ZpG__memberLocationDot",
  "memberLogo": "ForClubsMembers-module-scss-module__h-1ZpG__memberLogo",
  "memberLogoImage": "ForClubsMembers-module-scss-module__h-1ZpG__memberLogoImage",
  "memberMeta": "ForClubsMembers-module-scss-module__h-1ZpG__memberMeta",
  "memberMetaIcon": "ForClubsMembers-module-scss-module__h-1ZpG__memberMetaIcon",
  "memberMetaItem": "ForClubsMembers-module-scss-module__h-1ZpG__memberMetaItem",
  "memberName": "ForClubsMembers-module-scss-module__h-1ZpG__memberName",
  "membersGrid": "ForClubsMembers-module-scss-module__h-1ZpG__membersGrid",
  "membersSection": "ForClubsMembers-module-scss-module__h-1ZpG__membersSection",
  "sectionEyebrow": "ForClubsMembers-module-scss-module__h-1ZpG__sectionEyebrow",
  "sectionHeader": "ForClubsMembers-module-scss-module__h-1ZpG__sectionHeader",
  "sectionTitle": "ForClubsMembers-module-scss-module__h-1ZpG__sectionTitle",
  "soonBadge": "ForClubsMembers-module-scss-module__h-1ZpG__soonBadge",
  "tab": "ForClubsMembers-module-scss-module__h-1ZpG__tab",
  "tabActive": "ForClubsMembers-module-scss-module__h-1ZpG__tabActive",
  "tabDisabled": "ForClubsMembers-module-scss-module__h-1ZpG__tabDisabled",
  "tabItem": "ForClubsMembers-module-scss-module__h-1ZpG__tabItem",
  "tabItemWide": "ForClubsMembers-module-scss-module__h-1ZpG__tabItemWide",
  "tabItemWithBadge": "ForClubsMembers-module-scss-module__h-1ZpG__tabItemWithBadge",
  "tabs": "ForClubsMembers-module-scss-module__h-1ZpG__tabs",
  "tabsSection": "ForClubsMembers-module-scss-module__h-1ZpG__tabsSection",
});
